import { call, put, take } from 'redux-saga/effects';
import { activateAccountFailure, activateAccountSuccess } from '../actions';
import { activate } from '../api';
import { ActivateAccountRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { fetchMeRequest, logoutRequest } from 'store/auth/actions';
import { FETCH_ME_FAILURE, FETCH_ME_SUCCESS } from 'store/auth/constants';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* activateAccountSaga(action: ActivateAccountRequestAction) {
  //yield put(logoutRequest());
  try {
    let err: ApiError | null;
    const { user, resetPassword } = action.payload;
    const response: ApiResponse = yield call(activate, user, resetPassword);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    let message: MessageData = {
      title: i18n.t('vat-checker.activated'),
      description: response?.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(fetchMeRequest());
    // Wait for current user to be in store before navigating, so header/sidebar render
    const result = yield take([FETCH_ME_SUCCESS, FETCH_ME_FAILURE]);
    if (result.type === FETCH_ME_SUCCESS) {
      yield put(push(routes.main));
    }
    yield put(activateAccountSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(activateAccountFailure());
  }
}
